'use strict';

/*jshint esversion: 6 */
function setBookingDates(arrivalDateString, departureDateString) {
	var event = new CustomEvent('flowQueryDatesEvent', {
		detail: {
			arrivalDate: arrivalDateString,
			departureDate: departureDateString
		}
	});
	window.dispatchEvent(event);
}
function setRoomTypeCode(roomCode) {
	var event = new CustomEvent('flowQueryRoomTypeEvent', {
		detail: {
			roomTypeCode: roomCode
		}
	});
	window.dispatchEvent(event);
}
function setRatePlanCode(ratePlan) {
	var event = new CustomEvent('flowQueryRatePlanEvent', {
		detail: {
			ratePlanCode: ratePlan
		}
	});
	window.dispatchEvent(event);
}

function setChainCodeAndHotelCode(chainCode, hotelCode) {
	var event = new CustomEvent("flowQueryBrandPropertyEvent", {
		detail: {
			chainCode: chainCode,
			hotelCode: hotelCode
		}
	});
	window.dispatchEvent(event);
}

(function ($) {
	$(document).ready(function () {
		// Update the booking Widget
		$('.js-book').on('click', function () {
			var rate, room;

			rate = null;
			room = null;

			if ($(this).data('rate-plan-code')) {
				rate = $(this).data('rate-plan-code');
			}

			if ($(this).data('room-type-code')) {
				room = $(this).data('room-type-code');
			}

			if (room !== null) {
				setRoomTypeCode(room);
			}
			if (rate !== null) {
				setRatePlanCode(rate);
			}

			window.scrollTo({ top: 0, behavior: 'smooth' });
			$('.check-rates').show();
			return false;
		});
	});
})(jQuery);